export default __webpack_public_path__ + "static/media/konservilo.60f43a8d.svg";